let customWindow: any = window;
customWindow.ENVIRONMENT = 'production';
customWindow.API_URL = 'https://fanaticka-api-us.azurewebsites.net/api/v1';
customWindow.API_URL_V2 = 'https://fanaticka-api-us.azurewebsites.net/api/v2';
customWindow.APP_INSIGHTS_ID = '903b769b-906d-4730-bb7f-0619f82d1d2d';
customWindow.STRIPE_KEY = 'pk_live_fwrIleb9sARM3UwShZwslggL008kGvMG00';


import './index.tsx';
